import { render, staticRenderFns } from "./booklet-bloks-dialog.vue?vue&type=template&id=5bd3a3b2&scoped=true"
import script from "./booklet-bloks-dialog.vue?vue&type=script&lang=ts"
export * from "./booklet-bloks-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3a3b2",
  null
  
)

export default component.exports